import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { DpNotification, GroupedDpNotifications } from '../../core/shared-models/notification.model';
import { DashboardService } from '../dashboard.service';
import { DbService } from '../../core/db/db.service';
import { NotificationService } from '../../core/notification/notification.service';
import { Router } from '@angular/router';
import { BaseItem } from '../../core/db/base-item.model';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../../core/utils/utils.service';
import { utils } from 'protractor';

@Component({
    selector: 'app-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
    @Input() showEmptyNotificationsInfo = false;

    // notifications
    //groupedNotifications: Array<GroupedDpNotifications> = [];

    notifications: Array<DpNotification> = [];
    notificationListSubscription: Subscription;

    currentModalNotification: DpNotification = null;
    notificationDetailsModalVisible = false;

    updateIntervalId = null;
    loading = true;

    constructor(
        private dashboardSrv: DashboardService,
        private db: DbService,
        private notify: NotificationService,
        private router: Router,
        private translate: TranslateService,
        public utils: UtilsService
    ) {}

    ngOnInit() {
        this.loading = true;
        this.notificationListSubscription = this.dashboardSrv.notifications$.subscribe((notificationList) => {
            if (notificationList == null) {
                this.loading = true; // we get null as first value from the behaviour subject, once it was loaded from api the value is always an array
                this.notifications = [];
            } else {
                this.notifications = notificationList;
                this.loading = false;
            }
        });

        // set interval to refresh data every 5 minutes
        this.updateIntervalId = setInterval(() => {
            this.dashboardSrv.loadNotifications();
        }, 300000);
    }

    ngOnDestroy() {
        if (this.notificationListSubscription) {
            this.notificationListSubscription.unsubscribe();
        }
        if (this.updateIntervalId != null) {
            clearInterval(this.updateIntervalId);
        }
    }

    manualRefresh() {
        this.loading = true;
        this.dashboardSrv.loadNotifications();
    }

    async onClickNotificationItem(notification: DpNotification) {
        this.utils.notificationSidebarVisible = false;

        // check if project exists locally, before redirecting
        try {
            let project = (await this.db.getItemById(notification.relatedProject.replace('project#', '')).toPromise()) as BaseItem;
            // project exists, navigate
            if (notification.relatedJob) {
                this.router.navigate(['/project', project._id, 'jobs'], {
                    queryParams: { jobId: notification.relatedJob.replace('job#', '') },
                });
            } else {
                this.router.navigate(['/project', project._id, 'jobs']);
            }
        } catch (dbErr) {
            this.notify.info(this.translate.instant('dashboard.status.project-not-shared'));
        }
    }

    async onDeleteNotification(notifications: DpNotification | Array<DpNotification>, event: MouseEvent) {
        if (!Array.isArray(notifications)) {
            notifications = [notifications];
        }
        event.stopPropagation();
        this.dashboardSrv.dismissNotifications(notifications);
    }

    async getTranslation(key: string): Promise<string> {
        let e = await firstValueFrom(this.translate.get(key));
        return e;
        // return this.translate.instant('shared.add');
    }

    onViewNotificationModal(notification: DpNotification) {
        this.currentModalNotification = notification;
        this.notificationDetailsModalVisible = true;
    }
}
